export const ROUTES = {
  CATALOG: '/[type]',
  ENTITY: '/[type]/[slug]',
  MAP: '/maps/[type]',
  POLICY: '/policy',
  FAQ: '/faq',
  SERVICES: '/services',
  SERVICES_ITEM: '/services/[slug]',
  CONTACTS: '/contacts',
  ABOUT: '/about',
  ADD: '/add',
  ADD_ENTITY: '/add/[type]',
  PROFILE: {},
};

export const getRouteHref = (route: string, params: Record<string, string>) => {
  return route.replace(/\[([^\]]+)\]/g, (_, key) => params[key]);
};
